type MediaQueryChangeHandler = (event: MediaQueryListEvent) => void;

export const getMediaQueryMatches = (query: string): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.matchMedia(query).matches;
};

export const subscribeToMediaQuery = (
  query: string,
  handler: MediaQueryChangeHandler
): (() => void) => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const mediaQueryList = window.matchMedia(query);
  mediaQueryList.addEventListener('change', handler);

  return () => {
    mediaQueryList.removeEventListener('change', handler);
  };
};
